import React from 'react';
import { useAppSelector } from '../hooks/redux';
import KYCFlow from '../components/KYC/KYCFlow';
import KYCStatusBadge from '../components/KYC/KYCStatusBadge';

const KYCPage = () => {
  const { user } = useAppSelector((state) => state.auth);
  const { status, expirationDate, expired } = useAppSelector((state) => state.kyc);

  return (
    <div className="container mx-auto px-4 py-8 max-w-5xl">
      <div className="mb-6">
        <h1 className="text-3xl font-bold mb-2 text-[var(--color-default-font)]">KYC Verification</h1>
        <div className="flex items-center gap-3 flex-wrap">
          <KYCStatusBadge 
            status={status} 
            citizenStatus={user?.kyc?.citizenStatus}
            expirationDate={expirationDate}
            expired={expired}
          />
          {user?.kyc?.submittedAt && (
            <span className="text-sm text-[var(--color-subtext-color)]">
              Submitted: {new Date(user.kyc.submittedAt).toLocaleDateString()}
            </span>
          )}
          {user?.kyc?.approvedAt && (
            <span className="text-sm text-[var(--color-subtext-color)]">
              Approved: {new Date(user.kyc.approvedAt).toLocaleDateString()}
            </span>
          )}
        </div>
      </div>

      <KYCFlow />
    </div>
  );
};

export default KYCPage;
